import { VAppBar } from 'vuetify/lib/components/VAppBar';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.latestError)?_c(VAppBar,{attrs:{"fixed":"","app":"","prominent":"","height":"100"}},[_c('alert',{attrs:{"error":_vm.latestError},on:{"close":_vm.removeLatestError}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }